<template>
  <div :class="[section.options.content.image.customClass, {'element-hidden': !visability('image')}]">
    <highliter
      v-model="section.name"
      :disable-toolbar="section.options.content.image.disableToolbar"
      section-type="element"
      class="highlight-element"
      :dublicate-deep="parentUID"
      :dublicate="section"
      @add-subject="$emit('add-subject')"
      @favorite="$emit('favorite', $el)"
      @flow="handleFlow"
      @move-to="to => $emit('move-to', to)"
      @dublicate="$emit('dublicate')"
      @delete="$emit('delete')"
      @click.stop.native="sectionSettings('image')"
    >
      <template slot="section-type-icon">
        <svg
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.8277 0.75H3.17231C1.97448 0.75 1 1.72451 1 2.92235V15.5777C1 16.7755 1.97448 17.75 3.17231 17.75H15.8277C17.0255 17.75 18 16.7755 18 15.5777V2.92235C18 1.72451 17.0255 0.75 15.8277 0.75ZM16.9987 15.5777C16.9987 16.2234 16.4734 16.7487 15.8277 16.7487H3.17235C2.52665 16.7487 2.00134 16.2234 2.00134 15.5777V13.7513L5.29692 10.9472C5.41718 10.8449 5.59262 10.8439 5.71401 10.9448L7.77839 12.659C7.97744 12.8242 8.26963 12.8107 8.45254 12.6276L13.3576 7.71502C13.4463 7.6262 13.5496 7.61757 13.6036 7.62032C13.6574 7.62308 13.7595 7.64227 13.8386 7.73972L16.9987 11.6308V15.5777H16.9987ZM14.6158 7.10837L16.9987 10.0424V2.92235C16.9987 2.27665 16.4734 1.75134 15.8277 1.75134H3.17235C2.52665 1.75134 2.00134 2.27665 2.00134 2.92235V12.4366L4.64803 10.1847C5.13977 9.76628 5.85709 9.76199 6.35377 10.1744L8.06672 11.5968L12.649 7.00746C12.9139 6.74217 13.2807 6.60132 13.6549 6.62025C14.0293 6.63947 14.3795 6.81737 14.6158 7.10837Z"
            fill="black"
          />
          <path
            d="M16.9987 15.5777V15.4277H16.8487V15.5777H16.9987ZM2.00134 13.7513L1.90414 13.637L1.85134 13.682V13.7513H2.00134ZM5.29692 10.9472L5.39412 11.0615L5.39412 11.0615L5.29692 10.9472ZM5.71401 10.9448L5.61819 11.0602L5.61819 11.0602L5.71401 10.9448ZM7.77839 12.659L7.68256 12.7744L7.68257 12.7744L7.77839 12.659ZM8.45254 12.6276L8.55867 12.7336L8.55869 12.7335L8.45254 12.6276ZM13.3576 7.71502L13.4638 7.821L13.4638 7.82099L13.3576 7.71502ZM13.6036 7.62032L13.6112 7.47052L13.6112 7.47052L13.6036 7.62032ZM13.8386 7.73972L13.7221 7.83427L13.7222 7.83429L13.8386 7.73972ZM16.9987 11.6308H17.1487V11.5776L17.1152 11.5362L16.9987 11.6308ZM16.9987 15.5777V15.7277H17.1487V15.5777H16.9987ZM16.9987 10.0424L16.8823 10.137L17.1487 10.465V10.0424H16.9987ZM14.6158 7.10837L14.4994 7.20292L14.4994 7.20293L14.6158 7.10837ZM2.00134 12.4366H1.85134V12.7611L2.09854 12.5508L2.00134 12.4366ZM4.64803 10.1847L4.74523 10.2989H4.74523L4.64803 10.1847ZM6.35377 10.1744L6.25794 10.2898L6.25795 10.2898L6.35377 10.1744ZM8.06672 11.5968L7.97089 11.7122L8.07618 11.7997L8.17287 11.7028L8.06672 11.5968ZM12.649 7.00746L12.7552 7.11345L12.7552 7.11344L12.649 7.00746ZM13.6549 6.62025L13.6626 6.47044L13.6625 6.47044L13.6549 6.62025ZM3.17231 0.9H15.8277V0.6H3.17231V0.9ZM1.15 2.92235C1.15 1.80735 2.05732 0.9 3.17231 0.9V0.6C1.89163 0.6 0.85 1.64167 0.85 2.92235H1.15ZM1.15 15.5777V2.92235H0.85V15.5777H1.15ZM3.17231 17.6C2.05732 17.6 1.15 16.6926 1.15 15.5777H0.85C0.85 16.8583 1.89163 17.9 3.17231 17.9V17.6ZM15.8277 17.6H3.17231V17.9H15.8277V17.6ZM17.85 15.5777C17.85 16.6926 16.9427 17.6 15.8277 17.6V17.9C17.1084 17.9 18.15 16.8583 18.15 15.5777H17.85ZM17.85 2.92235V15.5777H18.15V2.92235H17.85ZM15.8277 0.9C16.9427 0.9 17.85 1.80735 17.85 2.92235H18.15C18.15 1.64167 17.1084 0.6 15.8277 0.6V0.9ZM15.8277 16.8987C16.5562 16.8987 17.1487 16.3062 17.1487 15.5777H16.8487C16.8487 16.1405 16.3905 16.5987 15.8277 16.5987V16.8987ZM3.17235 16.8987H15.8277V16.5987H3.17235V16.8987ZM1.85134 15.5777C1.85134 16.3062 2.44381 16.8987 3.17235 16.8987V16.5987C2.60949 16.5987 2.15134 16.1405 2.15134 15.5777H1.85134ZM1.85134 13.7513V15.5777H2.15134V13.7513H1.85134ZM5.19971 10.833L1.90414 13.637L2.09854 13.8655L5.39412 11.0615L5.19971 10.833ZM5.80984 10.8294C5.63241 10.682 5.37552 10.6834 5.19971 10.833L5.39412 11.0615C5.45883 11.0064 5.55284 11.0059 5.61819 11.0602L5.80984 10.8294ZM7.87421 12.5436L5.80984 10.8294L5.61819 11.0602L7.68256 12.7744L7.87421 12.5436ZM8.34642 12.5215C8.21828 12.6498 8.01363 12.6593 7.8742 12.5436L7.68257 12.7744C7.94125 12.9891 8.32097 12.9715 8.55867 12.7336L8.34642 12.5215ZM13.2515 7.60903L8.3464 12.5216L8.55869 12.7335L13.4638 7.821L13.2515 7.60903ZM13.6112 7.47052C13.5339 7.46657 13.3814 7.47888 13.2514 7.60905L13.4638 7.82099C13.5112 7.77352 13.5653 7.76857 13.5959 7.77013L13.6112 7.47052ZM13.955 7.64517C13.8391 7.50237 13.6885 7.47448 13.6112 7.47052L13.5959 7.77013C13.6263 7.77168 13.6798 7.78217 13.7221 7.83427L13.955 7.64517ZM17.1152 11.5362L13.955 7.64516L13.7222 7.83429L16.8823 11.7254L17.1152 11.5362ZM17.1487 15.5777V11.6308H16.8487V15.5777H17.1487ZM16.9987 15.7277H16.9987V15.4277H16.9987V15.7277ZM17.1151 9.94783L14.7323 7.0138L14.4994 7.20293L16.8823 10.137L17.1151 9.94783ZM16.8487 2.92235V10.0424H17.1487V2.92235H16.8487ZM15.8277 1.90134C16.3906 1.90134 16.8487 2.35948 16.8487 2.92235H17.1487C17.1487 2.19381 16.5563 1.60134 15.8277 1.60134V1.90134ZM3.17235 1.90134H15.8277V1.60134H3.17235V1.90134ZM2.15134 2.92235C2.15134 2.35949 2.60949 1.90134 3.17235 1.90134V1.60134C2.4438 1.60134 1.85134 2.1938 1.85134 2.92235H2.15134ZM2.15134 12.4366V2.92235H1.85134V12.4366H2.15134ZM4.55082 10.0704L1.90414 12.3223L2.09854 12.5508L4.74523 10.2989L4.55082 10.0704ZM6.4496 10.059C5.89684 9.60003 5.09808 9.6048 4.55082 10.0704L4.74523 10.2989C5.18145 9.92775 5.81734 9.92396 6.25794 10.2898L6.4496 10.059ZM8.16255 11.4814L6.4496 10.059L6.25795 10.2898L7.97089 11.7122L8.16255 11.4814ZM12.5429 6.90148L7.96057 11.4908L8.17287 11.7028L12.7552 7.11345L12.5429 6.90148ZM13.6625 6.47044C13.246 6.44937 12.8378 6.60605 12.5429 6.90148L12.7552 7.11344C12.9899 6.87829 13.3154 6.75327 13.6473 6.77005L13.6625 6.47044ZM14.7323 7.01381C14.4692 6.68982 14.0794 6.49185 13.6626 6.47044L13.6472 6.77005C13.9792 6.78709 14.2899 6.94493 14.4994 7.20292L14.7323 7.01381Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.83325 5.35417C3.83325 3.98719 4.94537 2.875 6.31242 2.875C7.67947 2.875 8.79159 3.98715 8.79159 5.35417C8.79159 6.72118 7.67943 7.83333 6.31242 7.83333C4.9454 7.83333 3.83325 6.72118 3.83325 5.35417ZM4.86148 5.35416C4.86148 6.1542 5.51236 6.80511 6.31243 6.80511C7.11251 6.80511 7.76339 6.1542 7.76339 5.35416C7.76339 4.55411 7.11251 3.9032 6.31243 3.9032C5.51236 3.9032 4.86148 4.55408 4.86148 5.35416Z"
            fill="black"
          />
        </svg>
      </template>

      <Template :section="section">
        <div :class="[shape.code, `image-${align}`]">
          <image-fit
            :customs="section.options.content.image"
            :src="section.options.content.image.src || section.options.content.image.placeholder"
            :size="cols(section.options.content.image.size, section.options.content.image.sizeSm || 'contain')"
            :position="section.options.content.image.position"
            :height="ratio.height"
            :width="ratio.width"
            @onload="img => image = img"
          />
        </div>
      </Template>
    </highliter>
  </div>
</template>

<script>
import SectionMixin from '@builder/components/mixins/SectionMixin'
import Highliter from '@builder/components/builder/utils/Highliter'
import Template from './Template'
import ImageFit from '../../../utils/ImageFit'

export default {
  name: 'FeaturedItems1',

  components: {ImageFit, Template, Highliter},

  mixins: [SectionMixin],

  computed: {
    align () {
      if (!this.section.options.content.image.align) {
        this.$set(this.section.options.content.image, 'align', {
          sm: 'center',
          lg: 'center'
        })
      }

      return this.section.options.content.image.align[this.resolution]
    },
    maskStyles () {
      return {
        maskSize: `${this.ratio.width} auto`
      }
    },
    shape () {
      if (!this.section.options.content.image.hasOwnProperty('shape')) {
        this.$set(this.section.options.content.image, 'shape', {
          code: null,
          name: 'No Shape',
          preview: null
        })
      }

      return this.section.options.content.image.shape
    },
    type () {
      return {
        w: this.section.options.content.image.ratio.typeW || this.section.options.content.image.ratio.type,
        h: this.section.options.content.image.ratio.typeH || this.section.options.content.image.ratio.type
      }
    },
    ratio () {
      if (!this.section.options.content.image.hasOwnProperty('ratio')) {
        this.$set(this.section.options.content.image, 'ratio', {
          type: '%',
          sm: {
            h: 100,
            w: 100
          },
          lg: {
            h: 100,
            w: 100
          }
        })
      }

      return {
        height: `${this.cols(this.section.options.content.image.ratio.lg.h, this.section.options.content.image.ratio.sm.h)}${this.type.h}`,
        width: `${this.cols(this.section.options.content.image.ratio.lg.w, this.section.options.content.image.ratio.sm.w)}${this.type.w}`
      }
    }
  },

  mounted () {
    if (!this.section.options.content.image.ratio.typeW) {
      setTimeout(() => {
        this.$set(this.section.options.content.image.ratio, 'typeW', '%')
        this.$set(this.section.options.content.image.ratio.lg, 'w', '100')
        this.$set(this.section.options.content.image.ratio.sm, 'w', '100')
      }, 1000)
    }
  }
}
</script>
